import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Hero.css';
import artistImage from '../assets/images/banner.png';

const Hero = () => {
  return (
    <section className="hero" aria-label="Hero banner - Welcome to Canvaart">
      <div className="hero-overlay"></div>
      
      <div className="hero-content">
        {/* Left Side - Text Content */}
        <motion.div
          className="hero-text-section"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            <span className="hero-tagline">Welcome to Canvaart</span>
          </motion.div>

          <motion.h1
            className="hero-title"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            <span className="hero-name">Aanishka Chowdhury</span>
            <span className="hero-role">Canvas Painting Specialist</span>
          </motion.h1>
          
          <motion.p
            className="hero-description"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Transforming emotions into breathtaking canvas art.
            Each piece tells a unique story, crafted with passion and precision.
          </motion.p>
          
          <motion.div
            className="hero-skills"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6 }}
          >
            <span className="skill-tag"><span aria-hidden="true">🎨</span> Abstract Art</span>
            <span className="skill-tag"><span aria-hidden="true">👤</span> Portraits</span>
            <span className="skill-tag"><span aria-hidden="true">🌄</span> Landscapes</span>
            <span className="skill-tag"><span aria-hidden="true">✨</span> Custom Work</span>
          </motion.div>

          <motion.div
            className="hero-stats"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7 }}
          >
            <div className="stat-item">
              <span className="hero-stat-number">500+</span>
              <span className="hero-stat-label">Artworks</span>
            </div>
            <div className="stat-item">
              <span className="hero-stat-number">200+</span>
              <span className="hero-stat-label">Happy Clients</span>
            </div>
            <div className="stat-item">
              <span className="hero-stat-number">10+</span>
              <span className="hero-stat-label">Years Experience</span>
            </div>
          </motion.div>
          
          <motion.div
            className="hero-buttons"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8 }}
          >
            <Link to="/gallery" className="btn-primary">Explore Gallery</Link>
            <Link to="/custom-request" className="btn-secondary">Request Custom Art</Link>
          </motion.div>
        </motion.div>

        {/* Right Side - Artist Image */}
        <motion.div
          className="hero-image-section"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <div className="artist-image-frame">
            <img src={artistImage} alt="Aanishka Chowdhury - Canvas Artist" />
          </div>
        </motion.div>
      </div>
      
      <div className="scroll-indicator">
        <p className="scroll-text">Scroll Down</p>
        <div className="mouse"></div>
      </div>
    </section>
  );
};

export default Hero;